import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import BlurModal from "../CommonComponents/BlurModal/BlurModal";
import BlurModalContent from "../CommonComponents/BlurModal/BlurModalContent";
import BlurModalHeading from "../CommonComponents/BlurModal/BlurModalHeading";
import HeadLines from "../CommonComponents/HeadLines";
import Loader from "../CommonComponents/Loader/Loader";
import {
  LOGIN_POPUP_APPEARING,
  LOGIN_POPUP_CLOSED,
} from "../GATracker3.0/constants";
import { eventTracker } from "../GATracker3.0/eventTracker";
import { isMobile } from "../helperFunc";
import NumberEntry from "./NumberEntry";
import OtpVerification from "./OtpVerification";
import style from "./style.module.css";
import { Validation } from "../CommonFunctions/validation/Validation";
import { userDetail } from "../GetInTouch/constant";
import { LoginServices } from "../../../../_services/Arya2.0/Login/LoginServices";
import { useDispatch, useSelector } from "react-redux";
import { setOTPUID } from "../Redux/UserInfo/actions";

const Login = ({
  show,
  setShow,
  setRegShow,
  otherModalProps = {},
  callBackFunction,
  goBack,
  ...props
}) => {
  const arya_shakti_number = useSelector(
    (globalState) => globalState?.aryaShaktiMobileReducer?.arya_shakti_number
  );
  const isDesktop = !isMobile;
  const [stepNo, setStepNo] = useState(
    props.stepNo ? props.stepNo : arya_shakti_number ? 1 : 0
  );
  const [mobileNumber, setMobileNumber] = useState(
    props.mobileNumber
      ? props.mobileNumber
      : arya_shakti_number
      ? arya_shakti_number
      : ""
  );
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [popupClosed, setPopUpClosed] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (show) {
      eventTracker("event", LOGIN_POPUP_APPEARING, {
        pagename: location.pathname === "/" ? "homepage" : location.pathname,
      });
    }
  }, [show]);

  useEffect(() => {
    if (arya_shakti_number) {
      sendOtpWhenAryashaktiMobileExists();
    }
  }, []);

  const sendOtpWhenAryashaktiMobileExists = async () => {
    let errobj = {};
    errobj = Validation(mobileNumber, userDetail());
    let flag = 0;
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      let dataObj = {
        mobile: mobileNumber,
      };
      let response = await LoginServices.sendOTPOnMobile(dataObj);
      if (response) {
        dispatch(
          setOTPUID({
            otpUid: response.data?.data?.uid,
          })
        );
        localStorage.removeItem("ssecretKey");
        setStepNo(1);
      }
    }
  };

  // useEffect(() => {
  //   if ( && getQueryParam("mobile")) {
  //     sendOtpWhenAryashaktiMobileExists();
  //   }
  // }, [aryaShaktiMobile]);

  const addInfoForLoginClose =
    popupClosed === "invalid"
      ? "invalid_otp"
      : popupClosed === "expired"
      ? "expired_otp"
      : popupClosed === "after"
      ? "after_otp"
      : "before_otp";

  return (
    <>
      <Loader isLoading={isLoading} />

      <BlurModal
        showDesktopHeader={isDesktop}
        desktopHeading="Login"
        className={"blur-modal login-modal"}
        show={show}
        onHide={() => {
          eventTracker("event", LOGIN_POPUP_CLOSED, {
            pagename:
              location.pathname === "/" ? "homepage" : location.pathname,
            addinfo: addInfoForLoginClose,
          });
          if (goBack) {
            goBack();
          } else {
            setShow(false);
          }
        }}
        {...otherModalProps}
      >
        <>
          <BlurModalHeading
            className={`padding-left16
                        padding-bottom16
                       `}
            showHeadingSepertor={!isDesktop}
            isDesktop={isDesktop}
            heading={
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                {isDesktop ? (
                  ""
                ) : (
                  <HeadLines
                    className={`font-weight600 
                            font-size18 
                            line-height21`}
                    text={"Login"}
                  />
                )}
                <HeadLines
                  className={`font-weight400 
                            ${
                              isDesktop
                                ? " font-size18 line-height21 "
                                : ` font-size12 line-height14 ${style["padding-top5"]} `
                            } letterSpacing025 colorAccent4 `}
                  text={
                    "To get access for all trade, storage and finance needs"
                  }
                />
              </div>
            }
          />
          <BlurModalContent className={"margin16 "}>
            <div
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              {stepNo == 0 ? (
                <NumberEntry
                  setStepNo={setStepNo}
                  setMobileNumber={setMobileNumber}
                  mobileNumber={mobileNumber}
                  setPopUpClosed={setPopUpClosed}
                  setIsLoading={setIsLoading}
                  isDesktop={isDesktop}
                />
              ) : (
                <OtpVerification
                  mobileNumber={mobileNumber}
                  setStepNo={setStepNo}
                  setPopUpClosed={setPopUpClosed}
                  setShow={setShow}
                  setIsLoading={setIsLoading}
                  setRegShow={setRegShow}
                  callBackFunction={callBackFunction}
                  isDesktop={isDesktop}
                />
              )}
            </div>
          </BlurModalContent>
        </>
      </BlurModal>
    </>
  );
};
export default Login;
